<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('payout.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('payout.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-end">
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading" :expandable="true">
        <template v-slot="{ record }">
          <td>{{ record.betting_no }}</td>
          <td>{{ record.betting_time }}</td>
          <td>
            <span
              class="ts-bg-blue-400 ts-px-1 ts-rounded-md ts-font-semibold ts-text-white"
            >{{ record.win_amount }}</span>
          </td>
          <!-- <td valign="middle">{{ record.betting_time }}</td>
          <td>
            <ul class="number-list ts-flex ts-space-x-2 ts-my-auto">
              <li
                v-for="(result, index) in spliteString(record.picked_number)"
                :key="index"
                class="ts-leading-8 ts-font-robot ts-rounded-full ts-text-center ts-text-heading-color ts-border ts-border-gray-500 ts-text-base ts-inline-block ts-h-8 ts-w-8"
              >
                {{ result }}
              </li>
            </ul>
          </td>
          <td>
            <span class="ts-font-semibold ts-text-heading-color">{{
              record.total_betting_amount
            }}</span>
          </td>-->
          <td class="text-center ts-whitespace-no-wrap">
            <a
              v-if="record.win_amount <= payoutLimit && record.win_amount > 0"
              href="#"
              v-tooltip="$t('payout.pay')"
              @click.prevent="pay(record)"
            >
              <i class="fas fa-money-check-alt"></i>
            </a>
            <a v-else href="#" v-tooltip="$t('payout.cannotPayout')" class="ts-text-red-600">
              <i class="fas fa-money-check-alt"></i>
            </a>
          </td>
        </template>
        <template v-slot:expand="{ record }">
          <table class="ts-w-6/12 ts-mx-auto">
            <tr>
              <td style="border:none">{{ $t('payout.pickedNumber') }}</td>
              <td style="border:none">{{ $t('payout.bettingAmount') }}</td>
              <td style="border:none">{{ $t('payout.amount') }}</td>
            </tr>
            <tr v-for="(data, index) in record.game_bettings" :key="index">
              <td>
                <ul class="number-list ts-flex ts-space-x-2 ts-my-auto">
                  <li
                    v-for="(result, index) in spliteString(data.picked_number)"
                    :key="index"
                    class="ts-leading-8 ts-font-robot ts-rounded-full ts-text-center ts-text-heading-color ts-border ts-border-gray-500 ts-text-base ts-inline-block ts-h-8 ts-w-8"
                  >{{ result }}</li>
                </ul>
              </td>
              <td>{{ data.total_betting_amount }}</td>
              <td>{{ data.win_amount }}</td>
            </tr>
          </table>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
    <a-modal
      v-model="show_form"
      :title="$t('payout.pageTitle')"
      :okText="$t('save')"
      :cancelText="$t('cancel')"
      :confirmLoading="waiting"
      @cancel="clearInput"
      @ok="onSave"
    >
      <div class="row">
        <div class="col-md-12">
          <textarea
            rows="3"
            class="form-control"
            v-model="model.description"
            :placeholder="$t('payout.description')"
          ></textarea>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import moment from 'moment'

export default {
  name: 'gameBetting',
  data() {
    return {
      visible: false,
      loading: false,
      waiting: false,
      show_form: false,
      errors: new Errors(),
      model: {
        ticket_number: null,
        description: null
      }
    }
  },
  computed: {
    ...mapState('accounting/payout', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.accounting.payout.search
      },
      set(newValue) {
        this.$store.commit('accounting/payout/SET_SEARCH', newValue)
        this.$store.commit('accounting/payout/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('payout.invoiceNumber') },
        { name: this.$t('payout.date') },
        { name: this.$t('payout.totalAmount') },
        { name: this.$t('actions'), style: 'text-align:center; width:10px' }
      ]
    },
    payoutLimit() {
      return parseFloat(this.$store.state.authUser.user.dealer.payout_limit)
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('accounting/payout/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    spliteString(value) {
      return value.split(',')
    },
    pay(record) {
      this.show_form = true
      this.model.ticket_number = record.ticket_number
    },
    clearInput() {
      this.show_form = false
      this.model.ticket_number = null
      this.model.description = null
    },
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('accounting/payout/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
          this.clearInput()
          this.show_form = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    spliteString(value) {
      return value.split(',')
    }
  },
  watch: {
    search: debounce(function(search) {
      if(search){
        this.fetchData({ search })
      }
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('accounting/payout/RESET_STATE')
    next()
  }
}
</script>
